import { client } from "api";
import { SerialEntity } from "models/Checklist";

export type CreateSerialEntityRequest = Pick<
  SerialEntity,
  | "checklistId"
  | "serialNumber"
  | "maker"
  | "model"
  | "macAddress"
  | "macAddressWifi"
  | "networkSocket"
  | "theftProtection"
  | "ipAddress"
  | "other"
  | "macAddressWifi"
  | "ipAddress"
  | "theftProtection"
  | "username"
  | "password"
>;

export type CreateSerialEntityResponse = SerialEntity;

export const createSerialEntity = (request: CreateSerialEntityRequest) =>
  client
    .post<CreateSerialEntityResponse>(`/checklist/serialEntity`, request)
    .then((res) => res.data);
